import { SelectProps } from 'antd';
import { useState } from 'react';
import { useDebounce } from '@/hooks';
import InfiniteSelect from '@/components/_common/InfiniteSelect';
import { ListManufacturersQuery } from '@/core/domain/operational/Manufacturers/Manufacturers.types';
import {
  useManufacturerDetailMutation,
  useManufacturers,
} from '@/core/domain/operational/Manufacturers/Manufacturers.hooks';
import useSelectOptions from '@/hooks/useSelectOptions';

type Props = Omit<SelectProps, 'options'> & {
  queryFilter?: ListManufacturersQuery;
  labelValue?: boolean;
};

const ManufacturerInfiniteSelectField: React.FC<Props> = ({
  queryFilter,
  labelValue,
  ...props
}) => {
  const [searchValue, setSearchValue] = useState<string>();
  const [selectClicked, setSelectClicked] = useState<boolean>(false);
  const search = useDebounce(searchValue);

  const manufacturesList = useManufacturers(
    {
      ...queryFilter,
      active: true,
      rows: 10,
      name: search,
    },
    selectClicked,
  );

  const detail = useManufacturerDetailMutation();

  const options = useSelectOptions({
    detail,
    selectProps: props,
    list: manufacturesList,
    labelFormatter: (item) => item.name,
  });

  const manufacturerOptions = options.map((cur) => ({
    value: labelValue ? String(cur.label) : cur.value,
    label: cur.label,
  }));

  return (
    <InfiniteSelect
      fetchNextPage={manufacturesList.fetchNextPage}
      hasNextPage={manufacturesList.hasNextPage}
      loading={manufacturesList.isFetching}
      options={manufacturerOptions}
      showSearch
      searchValue={searchValue}
      filterOption={false}
      onSearch={setSearchValue}
      onSelect={() => setSelectClicked(false)}
      onDropdownVisibleChange={(open) => setSelectClicked(open)}
      {...props}
    />
  );
};

export default ManufacturerInfiniteSelectField;
